module.exports = __webpack_public_path__ + "static/media/reformer9.bb99fc5d.jpg";